import React from 'react';
import './links.scss';

import cocurricularIcon from '../../../../assets/exploraplus-icon.svg';
import toolsIcon from '../../../../assets/virtualtools.svg';
import graduatedcon from '../../../../assets/graduado-icon.svg';
import academicIcon from '../../../../assets/academico-icon.svg';

const Links = ({ animationStates, linkState, handleCurrentLinkState }) => {
    const {
        studentProfileState,
        setStudentProfileState,
        academicAreasState,
        setAcademicAreasState,
        alliesState,
        setAlliesState,
        toolsState,
        setToolsState,
        cocurricularState,
        setCocurricularState,
        blankState,
        setBlankState
    } = animationStates;

    return (
        <div className="activities-links">
            <div className="row activities-links-row">
                {/* 1. PERFIL ACADÉMICO / EGRESADO */}
                <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                    <div
                        onClick={() => {
                            handleCurrentLinkState({
                                studentProfileLinkState: true,
                                academicAreasLinkState: false,
                                alliesLinkState: false,
                                toolsLinkState: false,
                                cocurricularLinkState: false,
                            });
                            if (document.querySelector(".curriculum")) document.querySelector(".curriculum").scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' });
                            setStudentProfileState({ active: true, enter: true });
                            setAcademicAreasState({ active: false, enter: false });
                            setAlliesState({ active: false, enter: false });
                            setToolsState({ active: false, enter: false });
                            setCocurricularState({ active: false, enter: false });
                            setBlankState({ active: false, enter: false });
                        }}
                    >
                        <div className="activities-link" style={linkState.studentProfileLinkState ? { background: "#fee860" } : {}}>
                            <div className="link-icon">
                                <img 
                                    className="icon-svg" 
                                    src={graduatedcon} 
                                    alt="Perfil Egresado" 
                                    style={linkState.studentProfileLinkState ? { filter: "invert(1) sepia(1) saturate(5) hue-rotate(175deg)" } : {}} 
                                />
                            </div>
                            <div className="link-text" style={linkState.studentProfileLinkState ? { color: "#0a415d" } : {}}>
                                Perfil Egresado
                            </div>
                        </div>
                    </div>
                </div>

                {/* 2. MODELO EDUCATIVO */}
                <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                    <div
                        onClick={() => {
                            handleCurrentLinkState({
                                studentProfileLinkState: false,
                                academicAreasLinkState: false,
                                alliesLinkState: false,
                                toolsLinkState: true,
                                cocurricularLinkState: false
                            });
                            if (document.querySelector(".curriculum")) document.querySelector(".curriculum").scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' });
                            setStudentProfileState({ active: false, enter: false });
                            setAcademicAreasState({ active: false, enter: false });
                            setAlliesState({ active: false, enter: false });
                            setToolsState({ active: true, enter: true });
                            setCocurricularState({ active: false, enter: false });
                            setBlankState({ active: false, enter: false });
                        }}
                    >
                        <div className="activities-link" style={linkState.toolsLinkState ? { background: "#fee860" } : {}}>
                            <div className="link-icon">
                                <img 
                                    className="icon-svg" 
                                    src={toolsIcon} 
                                    alt="Modelo Educativo" 
                                    style={linkState.toolsLinkState ? { filter: "invert(1) sepia(1) saturate(5) hue-rotate(175deg)" } : {}} 
                                />
                            </div>
                            <div className="link-text" style={linkState.toolsLinkState ? { color: "#0a415d" } : {}}>
                                Modelo Educativo
                            </div>
                        </div>
                    </div>
                </div>

                {/* 3. ÁREAS ACADÉMICAS */}
                <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                    <div
                        onClick={() => {
                            handleCurrentLinkState({
                                studentProfileLinkState: false,
                                academicAreasLinkState: true,
                                alliesLinkState: false,
                                toolsLinkState: false,
                                cocurricularLinkState: false
                            });
                            if (document.querySelector(".curriculum")) document.querySelector(".curriculum").scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' });
                            setStudentProfileState({ active: false, enter: false });
                            setAcademicAreasState({ active: true, enter: true });
                            setAlliesState({ active: false, enter: false });
                            setToolsState({ active: false, enter: false });
                            setCocurricularState({ active: false, enter: false });
                            setBlankState({ active: false, enter: false });
                        }}
                    >
                        <div className="activities-link" style={linkState.academicAreasLinkState ? { background: "#fee860" } : {}}>
                            <div className="link-icon">
                                <img 
                                    className="icon-svg" 
                                    src={academicIcon} 
                                    alt="Áreas Académicas" 
                                    style={linkState.academicAreasLinkState ? { filter: "invert(1) sepia(1) saturate(5) hue-rotate(175deg)" } : {}} 
                                />
                            </div>
                            <div className="link-text" style={linkState.academicAreasLinkState ? { color: "#0a415d" } : {}}>
                                Áreas Académicas
                            </div>
                        </div>
                    </div>
                </div>

                {/* 4. ACTIVIDADES INTERDISCIPLINARIAS */}
                <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                    <div
                        onClick={() => {
                            handleCurrentLinkState({
                                studentProfileLinkState: false,
                                academicAreasLinkState: false,
                                alliesLinkState: false,
                                toolsLinkState: false,
                                cocurricularLinkState: true,
                            });
                            if (document.querySelector(".curriculum")) document.querySelector(".curriculum").scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' });
                            setStudentProfileState({ active: false, enter: false });
                            setAcademicAreasState({ active: false, enter: false });
                            setCocurricularState({ active: true, enter: true });
                            setAlliesState({ active: false, enter: false });
                            setToolsState({ active: false, enter: false });
                            setBlankState({ active: false, enter: false });
                        }}
                    >
                        <div className="activities-link" style={linkState.cocurricularLinkState ? { background: "#fee860" } : {}}>
                            <div className="link-icon">
                                <img 
                                    className="icon-svg" 
                                    src={cocurricularIcon} 
                                    alt="Actividades Interdisciplinarias" 
                                    style={linkState.cocurricularLinkState ? { filter: "invert(1) sepia(1) saturate(5) hue-rotate(175deg)" } : {}} 
                                />
                            </div>
                            <div className="link-text" style={linkState.cocurricularLinkState ? { color: "#0a415d" } : {}}>
                                Actividades Interdisciplinarias
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Links;
